import { useState } from "react";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";

const REASONS = ["scam", "wrong_category", "offensive", "duplicate", "sold", "suspicious", "other"];

export const ReportButton = ({ itemType, itemId, testid = "report-button", label }) => {
  const { t, user } = useApp();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");
  const [contact, setContact] = useState("");
  const submit = async () => {
    try {
      await api.post("/reports", { item_type: itemType, item_id: itemId, reason, notes, contact });
      toast.success(t("report_sent")); setOpen(false); setReason(""); setNotes("");
    } catch { toast.error(t("error")); }
  };
  return (
    <>
      <button data-testid={testid} onClick={() => setOpen(true)} className="press inline-flex items-center gap-2 min-h-[44px] px-4 rounded-full bg-[#F3EDE4] text-[#6B5E55] font-semibold text-sm">
        <Flag className="w-4 h-4" aria-hidden="true" /> {label || t("report")}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="report-dialog" className="rounded-[24px] bg-[#FFFDF9] max-w-md">
          <DialogTitle className="text-xl font-extrabold">{t("report_title")}</DialogTitle>
          <DialogDescription className="sr-only">{t("report_reason")}</DialogDescription>
          <div className="space-y-2" role="radiogroup" aria-label={t("report_reason")}>
            {REASONS.map((r) => (
              <button key={r} role="radio" aria-checked={reason === r} data-testid={`report-reason-${r}`} onClick={() => setReason(r)}
                className={`press w-full text-left min-h-[48px] px-4 rounded-2xl border-2 font-semibold ${reason === r ? "border-[#C2410C] bg-[#FFF4EA]" : "border-[#E8E2D9]"}`}>{t(`r_${r}`)}</button>
            ))}
          </div>
          <textarea data-testid="report-notes" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder={t("report_notes")} rows={2} className="w-full rounded-2xl border border-[#E8E2D9] bg-[#FAF7F2] p-3 text-base" />
          {!user && <input data-testid="report-contact" value={contact} onChange={(e) => setContact(e.target.value)} placeholder={t("report_contact")} className="w-full min-h-[48px] rounded-2xl border border-[#E8E2D9] bg-[#FAF7F2] px-4 text-base" />}
          <button data-testid="report-submit" disabled={!reason} onClick={submit} className="press w-full min-h-[52px] rounded-full bg-[#C2410C] text-white font-extrabold disabled:opacity-40">{t("submit")}</button>
        </DialogContent>
      </Dialog>
    </>
  );
};
